import getCountries, { CountryOption } from '@api/getCountries'
import getStates, { StateOption, StateIndex } from '@api/getStates'
import { useState, useEffect } from 'react'
import { sortCountries, popularCountries } from '../utils/countries'

let stateCache: StateIndex | null = null
let countryCache: CountryOption[] | null = null

export default function useGetLocales(): [
  CountryOption[],
  (country: string) => StateOption[],
  boolean
] {
  const [states, setStates] = useState<StateIndex>(stateCache || {})
  const [countries, setCountries] = useState<CountryOption[]>(
    countryCache || []
  )
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      if (!stateCache) {
        setIsLoading(true)
        stateCache = await getStates()
      }
      if (!countryCache) {
        setIsLoading(true)
        countryCache = sortCountries(await getCountries(), popularCountries)
      }
      setStates(stateCache)
      setCountries(countryCache)
      setIsLoading(false)
    }
    fetchData()
  }, [])
  const getStatesByCountry = (country: string) => {
    return states[country] || []
  }
  return [countries, getStatesByCountry, isLoading]
}
